// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"888dc386","515":"1f6763a8"}[chunkId] + ".chunk.js";
};